const C = {
  text: 'rgba(214, 236, 247, 0.92)',
  muted: 'rgba(154, 186, 206, 0.72)',
  split: 'rgba(38, 164, 178, 0.18)',
  axis: 'rgba(120, 170, 190, 0.45)'
}

const tooltipDark = {
  backgroundColor: 'rgba(6, 22, 40, 0.92)',
  borderColor: 'rgba(38, 224, 208, 0.35)',
  textStyle: { color: C.text, fontSize: 12 }
}

export function pieOption(data, unit) {
  const u = unit || '人'
  return {
    tooltip: { ...tooltipDark, trigger: 'item', formatter: `{b}<br/>{c} ${u}  {d}%` },
    legend: { show: false },
    series: [
      {
        type: 'pie',
        radius: ['34%', '54%'],
        center: ['50%', '52%'],
        avoidLabelOverlap: true,
        minShowLabelAngle: 0,
        itemStyle: {
          borderColor: '#071422',
          borderWidth: 2
        },
        label: {
          show: true,
          color: C.text,
          fontSize: 11,
          lineHeight: 14,
          overflow: 'none',
          formatter: '{b}\n{d}%'
        },
        labelLine: {
          show: true,
          length: 12,
          length2: 14,
          maxSurfaceAngle: 80,
          lineStyle: { color: 'rgba(160, 200, 220, 0.45)' }
        },
        data
      }
    ]
  }
}

export function lineOption(xAxis, series) {
  return {
    tooltip: {
      ...tooltipDark,
      trigger: 'axis'
    },
    legend: {
      top: 0,
      right: 8,
      icon: 'roundRect',
      itemWidth: 10,
      itemHeight: 6,
      textStyle: { color: C.muted, fontSize: 11 }
    },
    grid: { left: 42, right: 16, top: 28, bottom: 28 },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxis,
      axisLine: { lineStyle: { color: C.axis } },
      axisTick: { show: false },
      axisLabel: { color: C.muted, fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      splitLine: { lineStyle: { color: C.split, type: 'dashed' } },
      axisLabel: { color: C.muted, fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    series: series.map(s => ({
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 6,
      ...s
    }))
  }
}

export function barOption(names, values, colors) {
  return {
    tooltip: { ...tooltipDark, trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 78, right: 36, top: 8, bottom: 8 },
    xAxis: {
      type: 'value',
      max: 100,
      splitLine: { lineStyle: { color: C.split, type: 'dashed' } },
      axisLabel: { color: C.muted, formatter: '{value}%', fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    yAxis: {
      type: 'category',
      data: names,
      inverse: true,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: C.text, fontSize: 11 }
    },
    series: [
      {
        type: 'bar',
        data: values.map((v, i) => ({
          value: v,
          itemStyle: {
            color: colors[i % colors.length],
            borderRadius: [0, 4, 4, 0]
          }
        })),
        barWidth: 10,
        label: {
          show: true,
          position: 'right',
          color: C.text,
          fontSize: 11,
          formatter: '{c}%'
        }
      }
    ]
  }
}

export function countBarOption(names, values, colors) {
  return {
    tooltip: { ...tooltipDark, trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 8, right: 32, top: 10, bottom: 8, containLabel: true },
    xAxis: {
      type: 'value',
      minInterval: 1,
      splitLine: { lineStyle: { color: C.split, type: 'dashed' } },
      axisLabel: { color: C.muted, fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    yAxis: {
      type: 'category',
      data: names,
      inverse: true,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        color: C.text,
        fontSize: 11,
        overflow: 'none'
      }
    },
    series: [
      {
        type: 'bar',
        barWidth: 10,
        data: values.map((v, i) => ({
          value: v,
          itemStyle: {
            color: (colors && colors[i % colors.length]) || '#2ee6d6',
            borderRadius: [0, 4, 4, 0]
          }
        })),
        label: { show: true, position: 'right', color: C.text, fontSize: 11 }
      }
    ]
  }
}

export function colBarOption(names, values, colors) {
  return {
    tooltip: { ...tooltipDark, trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 8, right: 8, top: 26, bottom: 4, containLabel: true },
    xAxis: {
      type: 'category',
      data: names,
      axisLabel: {
        color: C.muted,
        fontSize: 11,
        interval: 0,
        rotate: 24,
        overflow: 'none'
      },
      axisLine: { lineStyle: { color: C.axis } },
      axisTick: { show: false }
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      splitLine: { lineStyle: { color: C.split, type: 'dashed' } },
      axisLabel: { color: C.muted, fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    series: [
      {
        type: 'bar',
        barMaxWidth: 22,
        data: values.map((v, i) => ({
          value: v,
          itemStyle: {
            color: (colors && colors[i % colors.length]) || '#2ee6d6',
            borderRadius: [3, 3, 0, 0]
          }
        })),
        label: {
          show: true,
          position: 'top',
          distance: 3,
          color: C.text,
          fontSize: 11
        }
      }
    ]
  }
}

export function vBarOption(xAxis, current, previous, names, showLabel) {
  const nameA = (names && names[0]) || '本期'
  const nameB = (names && names[1]) || '同期'
  const valueLabel = showLabel
    ? {
      show: true,
      position: 'top',
      distance: 2,
      color: C.text,
      fontSize: 11,
      formatter: '{c}'
    }
    : { show: false }
  return {
    tooltip: { ...tooltipDark, trigger: 'axis' },
    legend: {
      top: 0,
      right: 8,
      icon: 'roundRect',
      itemWidth: 10,
      itemHeight: 6,
      textStyle: { color: C.muted, fontSize: 11 }
    },
    grid: { left: 36, right: 12, top: showLabel ? 40 : 28, bottom: 24 },
    xAxis: {
      type: 'category',
      data: xAxis,
      axisLabel: { color: C.muted, fontSize: 10 },
      axisLine: { lineStyle: { color: C.axis } },
      axisTick: { show: false }
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      splitLine: { lineStyle: { color: C.split, type: 'dashed' } },
      axisLabel: { color: C.muted, fontSize: 11 },
      axisLine: { show: false },
      axisTick: { show: false }
    },
    series: [
      {
        name: nameA,
        type: 'bar',
        barWidth: 12,
        barGap: '40%',
        itemStyle: { color: '#2ee6d6', borderRadius: [2, 2, 0, 0] },
        label: valueLabel,
        data: current
      },
      {
        name: nameB,
        type: 'bar',
        barWidth: 12,
        itemStyle: { color: 'rgba(79,195,247,0.45)', borderRadius: [2, 2, 0, 0] },
        label: valueLabel,
        data: previous
      }
    ]
  }
}

export function radarOption(indicators, values) {
  return {
    tooltip: { ...tooltipDark },
    radar: {
      indicator: indicators,
      splitNumber: 4,
      axisName: { color: C.muted, fontSize: 11 },
      splitLine: { lineStyle: { color: 'rgba(46,230,214,0.22)' } },
      splitArea: { areaStyle: { color: ['rgba(46,230,214,0.05)', 'rgba(4,16,28,0.2)'] } },
      axisLine: { lineStyle: { color: 'rgba(46,230,214,0.28)' } }
    },
    series: [
      {
        type: 'radar',
        symbol: 'circle',
        symbolSize: 5,
        data: [
          {
            value: values,
            name: '综合能力',
            areaStyle: { color: 'rgba(46,230,214,0.28)' },
            lineStyle: { color: '#2ee6d6', width: 2 },
            itemStyle: { color: '#2ee6d6' }
          }
        ]
      }
    ]
  }
}

export function gaugeOption(percent) {
  return {
    series: [
      {
        type: 'gauge',
        startAngle: 210,
        endAngle: -30,
        min: 0,
        max: 100,
        radius: '92%',
        center: ['50%', '58%'],
        pointer: { show: false },
        progress: {
          show: true,
          width: 14,
          roundCap: true,
          itemStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                { offset: 0, color: '#1ec8b8' },
                { offset: 1, color: '#f0c36a' }
              ]
            }
          }
        },
        axisLine: {
          lineStyle: { width: 14, color: [[1, 'rgba(38, 164, 178, 0.16)']] }
        },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        title: { show: false },
        detail: {
          offsetCenter: [0, '8%'],
          formatter: '{value}%',
          color: '#e8fbff',
          fontSize: 28,
          fontWeight: 700
        },
        data: [{ value: percent }]
      }
    ]
  }
}
